import ErrorFallbacks from "@src/components/ErrorFallbacks";
import React from "react";
import { quitWebviewDeeplink } from "@src/utils/goBack";

const NoInternetPage = () => {
  return <ErrorFallbacks statusCode={504} />;
};

NoInternetPage.getLayoutProps = () => ({
  handleBack: quitWebviewDeeplink,
  noPullToRefresh: true,
  noFooter: true,
});

export default NoInternetPage;
